import * as PopoverPrimitive from "@radix-ui/react-popover";
import * as React from "react";

import { cn } from "../../lib/utils";

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

// Optional anchor: lets the popover be positioned by an element other than
// the trigger (e.g. open aligned to the field, not the button inside it).
const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = React.forwardRef<
	React.ElementRef<typeof PopoverPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
		/** false renders without a Portal (needed inside a Dialog so the mouse wheel can scroll) */
		portal?: boolean;
	}
>(
	(
		{ className, align = "center", sideOffset = 4, portal = true, ...props },
		ref,
	) => {
		const content = (
			<PopoverPrimitive.Content
				ref={ref}
				align={align}
				sideOffset={sideOffset}
				className={cn(
					"z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
					className,
				)}
				{...props}
			/>
		);
		// Without a portal, the content stays in the subtree of the dialog that
		// contains it — and that is what makes the mouse wheel work: Radix
		// Dialog's react-remove-scroll blocks scrolling on any node outside it.
		return portal ? (
			<PopoverPrimitive.Portal>{content}</PopoverPrimitive.Portal>
		) : (
			content
		);
	},
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger };
